<template>
  <v-row>
    <v-col
      v-for="image in images"
      :key="image.index"
      class="d-flex child-flex"
      cols="12"
      md="6"
      lg="4"
    >
      <v-card class="d-flex">
        <PhotoImage :image="image" />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { apiGirlsData } from "@/plugins/api.js";
import PhotoImage from "@/components/PhotoImage.vue";
export default {
  name: "Photo",
  data: () => ({ images: {} }),
  components: {
    PhotoImage,
  },
  mounted() {
    (async () => {
      try {
        const { data } = await apiGirlsData();
        this.images = data.data;
      } catch (err) {
        console.log(err);
      }
    })();
  },
};
</script>
